// ***** Email Inbound Actions *****/

import {
  EMAIL_INBOUND_GET_LIST,
  EMAIL_INBOUND_GET_LIST_SUCCESS,
  EMAIL_INBOUND_GET_LIST_ERROR,
  EMAIL_OUTBOUND_SEND_EMAIL,
  EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS,
  EMAIL_OUTBOUND_SEND_EMAIL_ERROR,
  EMAIL_INBOUND_GET_SINGLE,
  EMAIL_INBOUND_GET_SINGLE_SUCCESS,
  EMAIL_INBOUND_GET_SINGLE_ERROR,
  EMAIL_INBOUND_ARCHIVE,
  EMAIL_INBOUND_ARCHIVE_SUCCESS,
  EMAIL_INBOUND_ARCHIVE_ERROR,
  EMAIL_INBOUND_MASS_MARKED_READ,
  EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS,
  EMAIL_INBOUND_MASS_MARKED_READ_ERROR,
  EMAIL_INBOUND_UPDATE_STAFF,
  EMAIL_INBOUND_UPDATE_STAFF_SUCCESS,
  EMAIL_INBOUND_UPDATE_STAFF_ERROR,
  EMAIL_OUTBOUND_ACCOUNT_LIST,
  EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS,
  EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR,
  EMAIL_INBOUND_ARCHIVE_LIST,
  EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS,
  EMAIL_INBOUND_ARCHIVE_LIST_ERROR,
  EMAIL_INBOUND_UNARCHIVE,
  EMAIL_INBOUND_UNARCHIVE_SUCCESS,
  EMAIL_INBOUND_UNARCHIVE_ERROR,
  EMAIL_INBOUND_MARK_AS_UNREAD,
  EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS,
  EMAIL_INBOUND_MARK_AS_UNREAD_ERROR,
  EMAIL_ACCOUNT_LIST,
  EMAIL_ACCOUNT_LIST_SUCCESS,
  EMAIL_ACCOUNT_LIST_ERROR,
  EMAIL_ACCOUNT_DETAILS,
  EMAIL_ACCOUNT_DETAILS_SUCCESS,
  EMAIL_ACCOUNT_DETAILS_ERROR,
  EMAIL_ACCOUNT_CREATE,
  EMAIL_ACCOUNT_CREATE_SUCCESS,
  EMAIL_ACCOUNT_CREATE_ERROR,
  EMAIL_ACCOUNT_UPDATE,
  EMAIL_ACCOUNT_UPDATE_SUCCESS,
  EMAIL_ACCOUNT_UPDATE_ERROR,
  EMAIL_ACCOUNT_DELETE,
  EMAIL_ACCOUNT_DELETE_SUCCESS,
  EMAIL_ACCOUNT_DELETE_ERROR,
  JOB_EMAIL_INBOUND_SEARCH,
  JOB_EMAIL_INBOUND_SEARCH_SUCCESS,
  JOB_EMAIL_INBOUND_SEARCH_ERROR,
  LINK_JOB_TO_EMAIL,
  LINK_JOB_TO_EMAIL_SUCCESS,
  LINK_JOB_TO_EMAIL_ERROR,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR,
  EMAIL_TEMPLATE_LIST,
  EMAIL_TEMPLATE_LIST_SUCCESS,
  EMAIL_TEMPLATE_LIST_ERROR,
  EMAIL_TEMPLATE_SEARCH,
  EMAIL_TEMPLATE_SEARCH_SUCCESS,
  EMAIL_TEMPLATE_SEARCH_ERROR,
  EMAIL_TEMPLATE_DATA,
  EMAIL_TEMPLATE_DATA_SUCCESS,
  EMAIL_TEMPLATE_DATA_ERROR,
  EMAIL_TEMPLATE_CREATE,
  EMAIL_TEMPLATE_CREATE_SUCCESS,
  EMAIL_TEMPLATE_CREATE_ERROR,
  EMAIL_TEMPLATE_UPDATE,
  EMAIL_TEMPLATE_UPDATE_SUCCESS,
  EMAIL_TEMPLATE_UPDATE_ERROR,
  EMAIL_TEMPLATE_DELETE,
  EMAIL_TEMPLATE_DELETE_SUCCESS,
  EMAIL_TEMPLATE_DELETE_ERROR,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR,
  EMAIL_DOMAIN_LIST,
  EMAIL_DOMAIN_LIST_SUCCESS,
  EMAIL_DOMAIN_LIST_ERROR,
  EMAIL_DOMAIN_DATA,
  EMAIL_DOMAIN_DATA_SUCCESS,
  EMAIL_DOMAIN_DATA_ERROR,
  EMAIL_DOMAIN_CREATE,
  EMAIL_DOMAIN_CREATE_SUCCESS,
  EMAIL_DOMAIN_CREATE_ERROR,
  EMAIL_DOMAIN_CHECK_DNS,
  EMAIL_DOMAIN_CHECK_DNS_SUCCESS,
  EMAIL_DOMAIN_CHECK_DNS_ERROR,
  EMAIL_DOMAIN_DELETE,
  EMAIL_DOMAIN_DELETE_SUCCESS,
  EMAIL_DOMAIN_DELETE_ERROR,
  EMAIL_INBOUND_REPLY_AUTOGENERATE,
  EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS,
  EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR,
  EMAIL_INBOUND_RULE_LIST,
  EMAIL_INBOUND_RULE_LIST_SUCCESS,
  EMAIL_INBOUND_RULE_LIST_ERROR,
  EMAIL_INBOUND_RULE_SEARCH,
  EMAIL_INBOUND_RULE_SEARCH_SUCCESS,
  EMAIL_INBOUND_RULE_SEARCH_ERROR,
  EMAIL_INBOUND_RULE_DATA,
  EMAIL_INBOUND_RULE_DATA_SUCCESS,
  EMAIL_INBOUND_RULE_DATA_ERROR,
  EMAIL_INBOUND_RULE_CREATE,
  EMAIL_INBOUND_RULE_CREATE_SUCCESS,
  EMAIL_INBOUND_RULE_CREATE_ERROR,
  EMAIL_INBOUND_RULE_UPDATE,
  EMAIL_INBOUND_RULE_UPDATE_SUCCESS,
  EMAIL_INBOUND_RULE_UPDATE_ERROR,
  EMAIL_INBOUND_RULE_DELETE,
  EMAIL_INBOUND_RULE_DELETE_SUCCESS,
  EMAIL_INBOUND_RULE_DELETE_ERROR,
  EMAIL_INBOUND_RULE_RUN,
  EMAIL_INBOUND_RULE_RUN_SUCCESS,
  EMAIL_INBOUND_RULE_RUN_ERROR,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR,
  SYSTEM_FUNCTION_OPERAND_LIST,
  SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS,
  SYSTEM_FUNCTION_OPERAND_LIST_ERROR,
} from "./actionType";

// get Email Inbound List
export const getEmailInboundList = () => ({
  type: EMAIL_INBOUND_GET_LIST,
});

// get Email Inbound List Success
export const getEmailInboundListSuccess = (data) => ({
  type: EMAIL_INBOUND_GET_LIST_SUCCESS,
  payload: data,
});

// get Email Inbound List Error
export const getEmailInboundListError = (error) => ({
  type: EMAIL_INBOUND_GET_LIST_ERROR,
  payload: error,
});

// get Email Inbound Single
export const getEmailInboundSingle = (id) => ({
  type: EMAIL_INBOUND_GET_SINGLE,
  payload: id,
});

// get Email Inbound Single Success
export const getEmailInboundSingleSuccess = (data) => ({
  type: EMAIL_INBOUND_GET_SINGLE_SUCCESS,
  payload: data,
});

// get Email Inbound Single Error
export const getEmailInboundSingleError = (error) => ({
  type: EMAIL_INBOUND_GET_SINGLE_ERROR,
  payload: error,
});
// Email Inbound Archive Emails
export const getEmailInboundArchive = (emails) => ({
  type: EMAIL_INBOUND_ARCHIVE,
  payload: emails,
});

// Email Inbound Archive Emails Success
export const getEmailInboundArchiveSuccess = (data) => ({
  type: EMAIL_INBOUND_ARCHIVE_SUCCESS,
  payload: data,
});

// Email Inbound Archive Emails Error
export const getEmailInboundArchiveError = (error) => ({
  type: EMAIL_INBOUND_ARCHIVE_ERROR,
  payload: error,
});

// Email Inbound Mass Marked Read
export const getEmailInboundMassMarkedRead = (emails) => ({
  type: EMAIL_INBOUND_MASS_MARKED_READ,
  payload: emails,
});

// Email Inbound Mass Marked Read Success
export const getEmailInboundMassMarkedReadSuccess = (data) => ({
  type: EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS,
  payload: data,
});

// Email Inbound Mass Marked Read Error
export const getEmailInboundMassMarkedReadError = (error) => ({
  type: EMAIL_INBOUND_MASS_MARKED_READ_ERROR,
  payload: error,
});
// send Email Outbound
export const sendEmailOutbound = (data) => ({
  type: EMAIL_OUTBOUND_SEND_EMAIL,
  payload: data,
});

// send Email Outbound Success
export const sendEmailOutboundSuccess = (data) => ({
  type: EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS,
  payload: data,
});

// send Email Outbound Error
export const sendEmailOutboundError = (error) => ({
  type: EMAIL_OUTBOUND_SEND_EMAIL_ERROR,
  payload: error,
});

// Email Staff assign update
export const getEmailInboundUpdateStaff = (data) => ({
  type: EMAIL_INBOUND_UPDATE_STAFF,
  payload: data,
});

// Email Staff assign update Success
export const getEmailInboundUpdateStaffSuccess = (data) => ({
  type: EMAIL_INBOUND_UPDATE_STAFF_SUCCESS,
  payload: data,
});

// Email Staff assign update Error
export const getEmailInboundUpdateStaffError = (error) => ({
  type: EMAIL_INBOUND_UPDATE_STAFF_ERROR,
  payload: error,
});

// get Email Outbound Account List
export const getEmailOutboundAccountList = () => ({
  type: EMAIL_OUTBOUND_ACCOUNT_LIST,
});

// get Email Outbound Account List Success
export const getEmailOutboundAccountListSuccess = (data) => ({
  type: EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS,
  payload: data,
});

// get Email Outbound Account List Error

export const getEmailOutboundAccountListError = (error) => ({
  type: EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR,
  payload: error,
});

// get Email Inbound Archive List
export const getEmailInboundArchiveList = () => ({
  type: EMAIL_INBOUND_ARCHIVE_LIST,
});

// get Email Inbound Archive List Success

export const getEmailInboundArchiveListSuccess = (data) => ({
  type: EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS,
  payload: data,
});

// get Email Inbound Archive List Error

export const getEmailInboundArchiveListError = (error) => ({
  type: EMAIL_INBOUND_ARCHIVE_LIST_ERROR,
  payload: error,
});

// Email Inbound Unarchive Emails
export const getEmailInboundUnarchive = (emails) => ({
  type: EMAIL_INBOUND_UNARCHIVE,
  payload: emails,
});

// Email Inbound Unarchive Emails Success
export const getEmailInboundUnarchiveSuccess = (data) => ({
  type: EMAIL_INBOUND_UNARCHIVE_SUCCESS,
  payload: data,
});

// Email Inbound Unarchive Emails Error
export const getEmailInboundUnarchiveError = (error) => ({
  type: EMAIL_INBOUND_UNARCHIVE_ERROR,
  payload: error,
});

// Email Inbound Mark as Unread
export const getEmailInboundMarkAsUnread = (emails) => ({
  type: EMAIL_INBOUND_MARK_AS_UNREAD,
  payload: emails,
});

// Email Inbound Mark as Unread Success
export const getEmailInboundMarkAsUnreadSuccess = (data) => ({
  type: EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS,
  payload: data,
});

// Email Inbound Mark as Unread Error
export const getEmailInboundMarkAsUnreadError = (error) => ({
  type: EMAIL_INBOUND_MARK_AS_UNREAD_ERROR,
  payload: error,
});

// Email Account List
export const getEmailAccountList = () => ({
  type: EMAIL_ACCOUNT_LIST,
});

// Email Account List Success
export const getEmailAccountListSuccess = (data) => ({
  type: EMAIL_ACCOUNT_LIST_SUCCESS,
  payload: data,
});

// Email Account List Error
export const getEmailAccountListError = (error) => ({
  type: EMAIL_ACCOUNT_LIST_ERROR,
  payload: error,
});

// Email Account Details
export const getEmailAccountDetails = (id) => ({
  type: EMAIL_ACCOUNT_DETAILS,
  payload: id,
});

// Email Account Details Success
export const getEmailAccountDetailsSuccess = (data) => ({
  type: EMAIL_ACCOUNT_DETAILS_SUCCESS,
  payload: data,
});

// Email Account Details Error
export const getEmailAccountDetailsError = (error) => ({
  type: EMAIL_ACCOUNT_DETAILS_ERROR,
  payload: error,
});

// Create Email Account
export const createEmailAccount = (data) => ({
  type: EMAIL_ACCOUNT_CREATE,
  payload: data,
});

// Create Email Account Success
export const createEmailAccountSuccess = (data) => ({
  type: EMAIL_ACCOUNT_CREATE_SUCCESS,
  payload: data,
});

// Create Email Account Error
export const createEmailAccountError = (error) => ({
  type: EMAIL_ACCOUNT_CREATE_ERROR,
  payload: error,
});

// Update Email Account
export const updateEmailAccount = (data) => ({
  type: EMAIL_ACCOUNT_UPDATE,
  payload: data,
});

// Update Email Account Success
export const updateEmailAccountSuccess = (data) => ({
  type: EMAIL_ACCOUNT_UPDATE_SUCCESS,
  payload: data,
});

// Update Email Account Error
export const updateEmailAccountError = (error) => ({
  type: EMAIL_ACCOUNT_UPDATE_ERROR,
  payload: error,
});

// Delete Email Account
export const deleteEmailAccount = (id) => ({
  type: EMAIL_ACCOUNT_DELETE,
  payload: id,
});

// Delete Email Account Success
export const deleteEmailAccountSuccess = (data) => ({
  type: EMAIL_ACCOUNT_DELETE_SUCCESS,
  payload: data,
});

// Delete Email Account Error
export const deleteEmailAccountError = (error) => ({
  type: EMAIL_ACCOUNT_DELETE_ERROR,
  payload: error,
});

// Job Email Inbound Search
export const jobEmailInboundSearch = (data) => ({
  type: JOB_EMAIL_INBOUND_SEARCH,
  payload: data,
});

// Job Email Inbound Search Success
export const jobEmailInboundSearchSuccess = (data) => ({
  type: JOB_EMAIL_INBOUND_SEARCH_SUCCESS,
  payload: data,
});

// Job Email Inbound Search Error
export const jobEmailInboundSearchError = (error) => ({
  type: JOB_EMAIL_INBOUND_SEARCH_ERROR,
  payload: error,
});

// Link Job To Email
export const linkJobToEmail = (data) => ({
  type: LINK_JOB_TO_EMAIL,
  payload: data,
});

// Link Job To Email Success
export const linkJobToEmailSuccess = (data) => ({
  type: LINK_JOB_TO_EMAIL_SUCCESS,
  payload: data,
});

// Link Job To Email Error
export const linkJobToEmailError = (error) => ({
  type: LINK_JOB_TO_EMAIL_ERROR,
  payload: error,
});

// Email Outbound Search Address Book
export const emailOutboundSearchAddressBook = (data) => ({
  type: EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK,
  payload: data,
});

// Email Outbound Search Address Book Success
export const emailOutboundSearchAddressBookSuccess = (data) => ({
  type: EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS,
  payload: data,
});

// Email Outbound Search Address Book Error
export const emailOutboundSearchAddressBookError = (error) => ({
  type: EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR,
  payload: error,
});

// Email Outbound Search Available Attachments
export const emailOutboundSearchAvailableAttachments = (data) => ({
  type: EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS,
  payload: data,
});

// Email Outbound Search Available Attachments Success
export const emailOutboundSearchAvailableAttachmentsSuccess = (data) => ({
  type: EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS,
  payload: data,
});

// Email Outbound Search Available Attachments Error
export const emailOutboundSearchAvailableAttachmentsError = (error) => ({
  type: EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR,
  payload: error,
});

// Email Template List
export const emailTemplateList = () => ({
  type: EMAIL_TEMPLATE_LIST,
});

// Email Template List Success
export const emailTemplateListSuccess = (data) => ({
  type: EMAIL_TEMPLATE_LIST_SUCCESS,
  payload: data,
});

// Email Template List Error
export const emailTemplateListError = (error) => ({
  type: EMAIL_TEMPLATE_LIST_ERROR,
  payload: error,
});

// Email Template Search
export const emailTemplateSearch = (data) => ({
  type: EMAIL_TEMPLATE_SEARCH,
  payload: data,
});

// Email Template Search Success
export const emailTemplateSearchSuccess = (data) => ({
  type: EMAIL_TEMPLATE_SEARCH_SUCCESS,
  payload: data,
});

// Email Template Search Error
export const emailTemplateSearchError = (error) => ({
  type: EMAIL_TEMPLATE_SEARCH_ERROR,
  payload: error,
});

// Email Template Data
export const emailTemplateData = (id) => ({
  type: EMAIL_TEMPLATE_DATA,
  payload: id,
});

// Email Template Data Success
export const emailTemplateDataSuccess = (data) => ({
  type: EMAIL_TEMPLATE_DATA_SUCCESS,
  payload: data,
});

// Email Template Data Error
export const emailTemplateDataError = (error) => ({
  type: EMAIL_TEMPLATE_DATA_ERROR,
  payload: error,
});

// Create Email Template
export const createEmailTemplate = (data) => ({
  type: EMAIL_TEMPLATE_CREATE,
  payload: data,
});

// Create Email Template Success
export const createEmailTemplateSuccess = (data) => ({
  type: EMAIL_TEMPLATE_CREATE_SUCCESS,
  payload: data,
});

// Create Email Template Error
export const createEmailTemplateError = (error) => ({
  type: EMAIL_TEMPLATE_CREATE_ERROR,
  payload: error,
});

// Update Email Template
export const updateEmailTemplate = (data) => ({
  type: EMAIL_TEMPLATE_UPDATE,
  payload: data,
});

// Update Email Template Success
export const updateEmailTemplateSuccess = (data) => ({
  type: EMAIL_TEMPLATE_UPDATE_SUCCESS,
  payload: data,
});

// Update Email Template Error
export const updateEmailTemplateError = (error) => ({
  type: EMAIL_TEMPLATE_UPDATE_ERROR,
  payload: error,
});

// Delete Email Template
export const deleteEmailTemplate = (id) => ({
  type: EMAIL_TEMPLATE_DELETE,
  payload: id,
});

// Delete Email Template Success
export const deleteEmailTemplateSuccess = (data) => ({
  type: EMAIL_TEMPLATE_DELETE_SUCCESS,
  payload: data,
});

// Delete Email Template Error
export const deleteEmailTemplateError = (error) => ({
  type: EMAIL_TEMPLATE_DELETE_ERROR,
  payload: error,
});

// Send Email Outbound Scheduled
export const sendEmailOutboundScheduled = (data) => ({
  type: EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED,
  payload: data,
});

// Send Email Outbound Scheduled Success
export const sendEmailOutboundScheduledSuccess = (data) => ({
  type: EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS,
  payload: data,
});

// Send Email Outbound Scheduled Error
export const sendEmailOutboundScheduledError = (error) => ({
  type: EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR,
  payload: error,
});

// Email Domain List
export const emailDomainList = () => ({
  type: EMAIL_DOMAIN_LIST,
});

// Email Domain List Success
export const emailDomainListSuccess = (data) => ({
  type: EMAIL_DOMAIN_LIST_SUCCESS,
  payload: data,
});

// Email Domain List Error
export const emailDomainListError = (error) => ({
  type: EMAIL_DOMAIN_LIST_ERROR,
  payload: error,
});

// Email Domain Data
export const emailDomainData = (id) => ({
  type: EMAIL_DOMAIN_DATA,
  payload: id,
});

// Email Domain Data Success
export const emailDomainDataSuccess = (data) => ({
  type: EMAIL_DOMAIN_DATA_SUCCESS,
  payload: data,
});

// Email Domain Data Error
export const emailDomainDataError = (error) => ({
  type: EMAIL_DOMAIN_DATA_ERROR,
  payload: error,
});

// Create Email Domain
export const createEmailDomain = (data) => ({
  type: EMAIL_DOMAIN_CREATE,
  payload: data,
});

// Create Email Domain Success
export const createEmailDomainSuccess = (data) => ({
  type: EMAIL_DOMAIN_CREATE_SUCCESS,
  payload: data,
});

// Create Email Domain Error
export const createEmailDomainError = (error) => ({
  type: EMAIL_DOMAIN_CREATE_ERROR,
  payload: error,
});

// Check Email Domain DNS
export const checkEmailDomainDNS = (id) => ({
  type: EMAIL_DOMAIN_CHECK_DNS,
  payload: id,
});

// Check Email Domain DNS Success
export const checkEmailDomainDNSSuccess = (data) => ({
  type: EMAIL_DOMAIN_CHECK_DNS_SUCCESS,
  payload: data,
});

// Check Email Domain DNS Error
export const checkEmailDomainDNSError = (error) => ({
  type: EMAIL_DOMAIN_CHECK_DNS_ERROR,
  payload: error,
});

// Delete Email Domain
export const deleteEmailDomain = (id) => ({
  type: EMAIL_DOMAIN_DELETE,
  payload: id,
});

// Delete Email Domain Success
export const deleteEmailDomainSuccess = (data) => ({
  type: EMAIL_DOMAIN_DELETE_SUCCESS,
  payload: data,
});

// Delete Email Domain Error
export const deleteEmailDomainError = (error) => ({
  type: EMAIL_DOMAIN_DELETE_ERROR,
  payload: error,
});

// Email Inbound Reply Autogenerate
export const emailInboundReplyAutogenerate = (data) => ({
  type: EMAIL_INBOUND_REPLY_AUTOGENERATE,
  payload: data,
});

// Email Inbound Reply Autogenerate Success
export const emailInboundReplyAutogenerateSuccess = (data) => ({
  type: EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS,
  payload: data,
});

// Email Inbound Reply Autogenerate Error
export const emailInboundReplyAutogenerateError = (error) => ({
  type: EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR,
  payload: error,
});

// ***** Email Inbound Rule Actions *****/

// Email Inbound Rule List
export const emailInboundRuleList = () => ({
  type: EMAIL_INBOUND_RULE_LIST,
});
export const emailInboundRuleListSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_LIST_SUCCESS,
  payload: data,
});
export const emailInboundRuleListError = (error) => ({
  type: EMAIL_INBOUND_RULE_LIST_ERROR,
  payload: error,
});

// Email Inbound Rule Search
export const emailInboundRuleSearch = (data) => ({
  type: EMAIL_INBOUND_RULE_SEARCH,
  payload: data,
});
export const emailInboundRuleSearchSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_SEARCH_SUCCESS,
  payload: data,
});
export const emailInboundRuleSearchError = (error) => ({
  type: EMAIL_INBOUND_RULE_SEARCH_ERROR,
  payload: error,
});

// Email Inbound Rule Data (single) — pass { id }
export const emailInboundRuleData = (id) => ({
  type: EMAIL_INBOUND_RULE_DATA,
  payload: id,
});
export const emailInboundRuleDataSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_DATA_SUCCESS,
  payload: data,
});
export const emailInboundRuleDataError = (error) => ({
  type: EMAIL_INBOUND_RULE_DATA_ERROR,
  payload: error,
});

// Create Email Inbound Rule
export const createEmailInboundRule = (data) => ({
  type: EMAIL_INBOUND_RULE_CREATE,
  payload: data,
});
export const createEmailInboundRuleSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_CREATE_SUCCESS,
  payload: data,
});
export const createEmailInboundRuleError = (error) => ({
  type: EMAIL_INBOUND_RULE_CREATE_ERROR,
  payload: error,
});

// Update Email Inbound Rule
export const updateEmailInboundRule = (data) => ({
  type: EMAIL_INBOUND_RULE_UPDATE,
  payload: data,
});
export const updateEmailInboundRuleSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_UPDATE_SUCCESS,
  payload: data,
});
export const updateEmailInboundRuleError = (error) => ({
  type: EMAIL_INBOUND_RULE_UPDATE_ERROR,
  payload: error,
});

// Delete Email Inbound Rule — pass [id]
export const deleteEmailInboundRule = (data) => ({
  type: EMAIL_INBOUND_RULE_DELETE,
  payload: data,
});
export const deleteEmailInboundRuleSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_DELETE_SUCCESS,
  payload: data,
});
export const deleteEmailInboundRuleError = (error) => ({
  type: EMAIL_INBOUND_RULE_DELETE_ERROR,
  payload: error,
});

// Run Email Inbound Rule on all mailboxes — pass { id }
export const runEmailInboundRule = (data) => ({
  type: EMAIL_INBOUND_RULE_RUN,
  payload: data,
});
export const runEmailInboundRuleSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_RUN_SUCCESS,
  payload: data,
});
export const runEmailInboundRuleError = (error) => ({
  type: EMAIL_INBOUND_RULE_RUN_ERROR,
  payload: error,
});

// Email Inbound Rule Item Field List (condition fields)
export const emailInboundRuleItemFieldList = () => ({
  type: EMAIL_INBOUND_RULE_ITEM_FIELD_LIST,
});
export const emailInboundRuleItemFieldListSuccess = (data) => ({
  type: EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS,
  payload: data,
});
export const emailInboundRuleItemFieldListError = (error) => ({
  type: EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR,
  payload: error,
});

// System Function Operand List (operators)
export const systemFunctionOperandList = () => ({
  type: SYSTEM_FUNCTION_OPERAND_LIST,
});
export const systemFunctionOperandListSuccess = (data) => ({
  type: SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS,
  payload: data,
});
export const systemFunctionOperandListError = (error) => ({
  type: SYSTEM_FUNCTION_OPERAND_LIST_ERROR,
  payload: error,
});
